import CommonContainer from "../Container/CommonContainer"
import React, { useState, useRef, useEffect } from 'react';
import * as DocumentService from '../../Services/Document/DocumentService';
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { FaAngleDown, FaAngleRight, FaDownload, FaEye, FaExclamationCircle, FaCloudUploadAlt, FaFileAlt } from "react-icons/fa";
import { allowedTypes } from "../../Common/CommonVariables";
import { store } from "../../Store/store";
// import DocumentSection from "./DocumentSection";
import "./DocumentComponent.css"

const DocumentCard = ({ title, description, downloadLink }) => {

  const [isExpanded, setIsExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const textRef = useRef(null);
  const maxLines = 2

  useEffect(() => {
    const checkTextOverflow = () => {
      if (textRef.current) {
        const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight);
        const maxHeight = lineHeight * maxLines;
        const actualHeight = textRef.current.scrollHeight;

        if (actualHeight > maxHeight) {
          setShowReadMore(true);
        } else {
          setShowReadMore(false);
        }
      }
    };

    checkTextOverflow();
    window.addEventListener('resize', checkTextOverflow);

    return () => window.removeEventListener('resize', checkTextOverflow);
  }, [description, maxLines]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleDownload = () => {
    // Check if downloadLink exists before attempting to open it
    if (downloadLink) {
      // Open the link in a new tab
      window.open(downloadLink, '_blank', 'noopener,noreferrer');
    } else {
      alert('Download link is not available for this document');
    }
  };

  return (
    <div className="col-sm-12 col-md-3 col-lg-3 mb-2" syle={{ margin: '0px', padding: '5px' }}>
      <div className="shadow bg-white rounded h-100">
        <div className="card-body p-3 d-flex flex-column justify-content-between" style={{ fontSize: 'small' }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <strong className="text-secondary">{title}</strong>
            <FaEye
              onClick={handleDownload}
              title="Click to View"
              style={{
                cursor: downloadLink ? 'pointer' : 'not-allowed',
                color: 'green',
              }}
              disabled={!downloadLink}
            />
          </div>
          <div className="border-top pt-2">
            <p
              ref={textRef}
              className={`mb-1 text-start ${!isExpanded ? 'text-truncate-custom' : ''}`}
              style={{
                display: '-webkit-box',
                WebkitLineClamp: !isExpanded ? maxLines : 'none',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                lineHeight: '1.5',
                fontSize: 'x-small'
              }}
            >
              {description}
            </p>
            {showReadMore && (
              <button
                onClick={toggleExpanded}
                className="btn btn-link p-0 text-decoration-none"
                style={{
                  color: '#007bff',
                  fontSize: 'x-small',
                  cursor: 'pointer',
                  border: 'none',
                  background: 'none'
                }}
              >
                {isExpanded ? 'Show less' : 'Show More'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const DocumentSection = ({ title, documents }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleSection = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="mb-2">
      {/* <div 
        className="card"
        style={{ overflow: 'hidden' }}
      > */}
      {/* Accordion Header */}
      <div
        className="card-header bg-light d-flex justify-content-between align-items-center"
        style={{ cursor: 'pointer' }}
        onClick={toggleSection}
      >
        <span className="fw-bold">{title}</span>
        <span>{isExpanded ? <FaAngleDown /> : <FaAngleRight />}</span>
      </div>

      {/* Collapsible Content */}
      {isExpanded && (
        <div className="card-body p-3">
          <div className="row">
            {documents && documents.length > 0 ? (
              documents.map((doc, index) => (
                <DocumentCard
                  key={index}
                  title={doc.Title}  // Changed from title to match DocumentCard props
                  description={doc.Document_Description}   // Changed from subtitle to match DocumentCard props
                  downloadLink={doc.Document_Url}
                />
              ))
            ) : (
              <div className="col-12 text-center p-3">
                <p className="text-muted">No documents available</p>
              </div>
            )}
          </div>
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

const DocumentComponent = () => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const fileInputRef = useRef(null);
  const [uploadModalShow, setUploadModalShow] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [partnerTypes, setPartnerTypes] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [documentCategoryList, setDocumentCategoryList] = useState([]);
  const userPartnerDet = useSelector((state) => state.userData);
  const [showNote, setShowNote] = useState(false);
  const userInfo = store.getState();

  useEffect(() => {
    // Only fetch when component mounts, not on every importantDocuments change
    //console.log(userInfo);
    const fetchDocuments = async () => {
      try {
        const documentCategory = await fetchAllDocumentCategory();
        setDocumentCategoryList(documentCategory);

        const documentList = await fetchActiveDocumentList();
        setDocumentsList(documentList);
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    fetchDocuments();
  }, []);

  const fetchActiveDocumentList = () => {
    DocumentService.GetActiveDocumentList()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setDocumentsList(data.Data);
        }
        else {
          setDocumentsList([]);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => { });
  }

  const handleMainFileUpload = (event) => {
    //debugger;
    const file = event.target.files[0];
    const maxFileSize = 5 * 1024 * 1024; // 5MB
    if (file) {
      if (!allowedTypes.includes(file.type) || file.size > maxFileSize) {
        toast.error('File is either unsupported or exceeds the 5MB limit.');
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        return;
      }

      // You can add logic here to determine which section/document to update
      setSelectedFiles(file);
    }
  };

  const handleButtonClick = () => {
    //debugger;
    fetchAllDocumentCategory();
    getAllPartnerTypes();
    getAllDocumentTypes();
  };

  const getAllDocumentTypes = () => {
    DocumentService.GetAllDocumentTypes()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setDocumentTypes(data.Data);
          setUploadModalShow(true);
        }
        else {
          setDocumentTypes([]);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => { });
  }

  const getAllPartnerTypes = () => {
    DocumentService.GetAllPartnerTypes()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setPartnerTypes(data.Data);
        }
        else {
          setDocumentTypes([]);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => { });
  }

  const handleModalClose = () => {
    reset();
    setUploadModalShow(false);
    setDocumentTypes([]);
  }

  const InsertNewDocumentDet = (data) => {
    const fullName = selectedFiles.name;              // e.g. "contract.pdf"
    const documentName = fullName.substring(0, fullName.lastIndexOf('.')) || fullName;

    const extension = selectedFiles.name.split('.').pop();         // "pdf"
    const documentType = "." + extension.toLowerCase();

    //data.PartnerId = userPartnerDet.UserId;
    data.Partner_Code = userPartnerDet.Partner_Code;
    data.Document_FileType = documentType;
    data.Document_Name = documentName;

    DocumentService.InsertNewDocumentDet(data)
      .then(({ data }) => {
        if (data.IsSuccess) {
          toast.success("Document saved successfully!");
          fetchActiveDocumentList();
          handleModalClose();
        } else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => { });
  }

  const onSubmit = (formDetails) => {
    const formData = new FormData();
    formData.append('file', selectedFiles);

    DocumentService.AddNewDocument(formData)
      .then(({ data }) => {
        if (data.IsSuccess) {
          formDetails.Document_Url = data.Data;
          InsertNewDocumentDet(formDetails);
        } else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => { });
  }

  const fetchAllDocumentCategory = () => {
    DocumentService.GetAllDocumentCategory()
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setDocumentCategoryList(data.Data);
        }
        else {
          setDocumentCategoryList([]);
        }
      })
      .catch(() => toast.error("Something went wrong during creation."))
      .finally(() => { });;
  }

  return (
    <>
      <CommonContainer 
      icon={<FaFileAlt/>}
        heading="Documents"
        {...(userInfo.userData.Role_Name === 'MHL-Admin' && {
          buttonText: (
            <span className="d-inline-flex align-items-center">
              <span className="d-none d-sm-inline">Document</span>
            </span>
          )
        })}
        onButtonClick={handleButtonClick}
      >
        {/* {documentCategoryList && documentCategoryList.map((docs, index) => {
          // Filter documents for this specific category
          const categoryDocuments = (documentsList || []).filter(doc =>
            doc.Document_Category_Id === docs.Document_Category_Id
          );

          // Only render if there are documents for this category
          if (categoryDocuments.length === 0) return null;

          return (
            <DocumentSection
              key={docs.Document_Category_Id} // Use ID instead of index for better key
              title={docs.Document_Category_Name}
              documents={categoryDocuments} // Pass filtered documents
            />
          );
        })} */}

        {/* Show message if no documents are available at all */}
        {/* {(!documentCategoryList || documentCategoryList.length === 0) && (
          <div className="alert alert-info text-center">
            No documents are currently available.
          </div>
        )} */}

        {(() => {
          if (!documentCategoryList || documentCategoryList.length === 0) {
            return (
              <div className="document-alert alert alert-info text-center">
                No documents are currently available.
              </div>
            );
          }

          let hasDocs = false;
          const sections = documentCategoryList.map((docs) => {
            const categoryDocuments = (documentsList || []).filter(
              (doc) => doc.Document_Category_Id === docs.Document_Category_Id
            );

            if (categoryDocuments.length > 0) {
              hasDocs = true;
              return (
                <DocumentSection
                  key={docs.Document_Category_Id}
                  title={docs.Document_Category_Name}
                  documents={categoryDocuments}
                />
              );
            }
            return null;
          });

          return hasDocs ? sections : (
            <div className="document-alert alert alert-info text-center">
              No documents are currently available.
            </div>
          );
        })()}

        {uploadModalShow && (
          <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-lg custom-modal" style={{ maxWidth: '700px' }} role="document">
                <div className="modal-content mb-0 p-0">
                  <div className="modal-header p-2-5">
                    <h5 className="modal-title">Document Upload</h5>
                    <button type="button" className="btn-close" onClick={handleModalClose}></button>
                  </div>
                  <div className="modal-body p-1">
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                      <div className="container" style={{ fontSize: "13px" }}>
                        <div className="d-flex align-items-center gap-2 mb-2" style={{ fontSize: "13px" }} >
                          <label className="fw-bold mb-0-5 required">Upload Document</label>
                          <input className="form-control" style={{ width: '60%', marginTop: '10px' }} type="file"
                            ref={fileInputRef}
                            accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.webp,.bmp,.svg,.eml"
                            {...register("Document_File", { required: "Please select document" })}
                            onChange={handleMainFileUpload}
                          />
                          {errors.Document_File && <p className="text-danger required_error">{errors.Document_File.message}</p>}
                          <div className="position-relative d-inline-block">
                            <FaExclamationCircle
                              className="ms-2"
                              size={16}
                              style={{ cursor: 'pointer' }}
                              onMouseEnter={() => setShowNote(true)}
                              onMouseLeave={() => setShowNote(false)}
                            />

                            {showNote && (
                              <div
                                className="alert alert-info p-2 mt-1 pt-2 position-absolute"
                                style={{
                                  fontSize: '9px',
                                  maxWidth: '350px',
                                  minWidth: '300px',
                                  marginBottom: '4px',
                                  top: '25px',
                                  left: '0',
                                  zIndex: 1000,
                                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                }}
                              >
                                <strong>Note:</strong> You can upload a maximum of 1 files(less than 5MB).<br />
                                Accepted file: <code>.pdf</code>, <code>.doc</code>, <code>.docx</code>, <code>.jpeg</code>, <code>.jpg</code>, <code>.png</code>, <code>.gif</code>, <code>.webp</code>, <code>.bmp</code>, <code>.svg</code>, <code>.eml</code>
                              </div>
                            )}
                          </div>
                        </div>

                        <ul className="list-group pl-3 pb-2 pt-1 col-md-6" >
                          {selectedFiles && selectedFiles.length > 0 ? (
                            selectedFiles.map((file) => (
                              <li key="" className="list-group-item d-flex align-items-center" >
                                {file.name}
                              </li>
                            ))
                          ) : (
                            null
                          )}
                        </ul>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className="fw-bold required mb-0-5">Title</label>
                            <input type="text" className="form-control" placeholder="Enter Title" {...register("Title", { required: "Title is required" })} />
                            {errors.Title && <p className="text-danger required_error">{errors.Title.message}</p>}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label required fw-bold mb-0-5">Document Category</label>
                            <div className="case-select-wrapper">
                              <select className="form-select case-dropdown" defaultValue={""} {...register("Document_Category_Id", { required: "Document category is required" })}>
                                <option value="">Select Document Category</option>
                                {documentCategoryList && documentCategoryList.map((item, index) => (
                                  <option key={index} value={item.Document_Category_Id}>
                                    {item.Document_Category_Name}
                                  </option>
                                ))}
                              </select>
                              {errors.Document_Category_Id && (<p className="text-danger required_error"> {errors.Document_Category_Id.message} </p>)}
                            </div>
                          </div>

                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label htmlFor="documentType" className="form-label form-label fw-bold">Document Type</label>
                            <select
                              className="form-select"
                              id="documentType"
                              {...register("Document_Type")}
                            >
                              <option value="">Select Document Type</option>
                              {documentTypes && documentTypes.map((type, index) => (
                                <option key={index} value={type}>{type}</option>
                              ))}
                            </select>
                            {/* {errors.Document_Type && <p className="text-danger required_error">{errors.Document_Type.message}</p>} */}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label required fw-bold">Description</label>
                            <textarea
                              className="form-control"
                              rows="3"
                              placeholder="Enter a description for the document"
                              {...register("Document_Description", { required: "Description is required" })}
                            ></textarea>
                            {errors.Document_Description && <p className="text-danger required_error">{errors.Document_Description.message}</p>}
                          </div>
                        </div>
                      </div>

                      <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                        <button type="button" className="btn btn-danger" onClick={handleModalClose}>Close</button>
                        <button type="submit" className="btn btn-primary">Save</button>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </CommonContainer>
    </>
  );
};

export default DocumentComponent;